import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './locales/zh';
import en from './locales/en';

const STORAGE_KEY = 'mycue_language';
const IP_DETECTED_KEY = 'mycue_lang_ip_detected';

const safeStorageGet = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeStorageSet = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Ignore storage failures on restrictive Android WebViews
  }
};

const fetchWithTimeout = (url: string, timeoutMs: number) => {
  if (typeof AbortController === 'undefined') {
    return fetch(url);
  }

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

  return fetch(url, { signal: controller.signal }).finally(() => {
    window.clearTimeout(timeoutId);
  });
};

const cachedLang = safeStorageGet(STORAGE_KEY);
const ipDetected = safeStorageGet(IP_DETECTED_KEY);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    lng: cachedLang || 'zh',
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false,
    },
  });

if (!cachedLang && !ipDetected) {
  void fetchWithTimeout('https://ipapi.co/json/', 3000)
    .then(async (res) => {
      if (!res.ok) throw new Error(`IP lookup failed: ${res.status}`);
      return res.json();
    })
    .then((data) => {
      const isChina = data?.country_code === 'CN' || data?.country === 'China';
      const lang = isChina ? 'zh' : 'en';
      i18n.changeLanguage(lang);
      safeStorageSet(STORAGE_KEY, lang);
      safeStorageSet(IP_DETECTED_KEY, '1');
    })
    .catch(() => {
      safeStorageSet(STORAGE_KEY, 'zh');
      safeStorageSet(IP_DETECTED_KEY, '1');
    });
}

export default i18n;
